module.exports = __webpack_public_path__ + "img/home.31617b99.png";